import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as rcc from "../../../../constants/rcc";
import * as resources from "../../../../constants/resources";
import * as settings from "../../../../constants/settings";
import * as navigationActions from "../../../../actions/navigationActions";
import * as rccActions from "../../../../actions/rccActions";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as validationHelper from "../../../../helpers/validationHelper";

import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import Input from "../../../global/generic/Input";
import Modal from "../../../global/generic/Modal";

import imgPurge from "../../../../resources/img/svgicons/purge.svg";

export class PurgeAllModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            volume: rcc.RCC_DEFAULT_PURGE_VOLUME
        };
    }

    handleVolumeFocus = (event) => {
        event.target.select();
    };

    handleVolumeChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                volume: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleVolumeBlur = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                volume: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    purgeAllChannels = (volume) => {
        this.props.dispatchPurgeAllChannelsAction(volume);
    };

    handleStartPurgeButtonClick = () => {
        if (Number(this.state.volume) > 0) {
            this.handleCloseModalClick();
            this.purgeAllChannels(Number(this.state.volume));
        }
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex flex-wrap flex-align-center-vertical padding-bottom-10">
                    <div className="col-6 pull-left">
                        <Translate value="purgeModal.purgeVolume" />
                    </div>
                    <Input
                        className="primary-input col-6"
                        value={this.state.volume}
                        onFocus={this.handleVolumeFocus}
                        onChange={this.handleVolumeChange}
                        onBlur={this.handleVolumeBlur}
                        disabled={this.props.loggedUser.canNotEdit(resources.MACHINE_ACTION_PURGE)}
                        labelAfter={settings.UNIT_ML}
                    />
                </div>
            </React.Fragment>
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    label={translate("purgeModal.purgeAll")}
                    svgBefore={imgPurge}
                    onClick={this.handleStartPurgeButtonClick}
                    disabled={Number(this.state.volume) <= 0}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="purgeModal.purgeAllChannels" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "30%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        loggedUser: store.login.loggedUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.PURGE_ALL_MODAL));
        },
        dispatchPurgeAllChannelsAction: (volume) => {
            dispatch(rccActions.purgeAllChannels(volume));
        }
    };
};

export default PurgeAllModal = connect(mapStoreToProps, mapDispatchToProps)(PurgeAllModal);
